<div class="container-fluid bg-gray-300 py-3 py-lg-5 position-relative overflow-hidden bg-watermark-logo">
	<div class="container d-lg-flex justify-content-between">
		<div class="image mb-4 mr-lg-3 z-1">
			<img src="/assets/images/home/travelers-photos-placeholder.png" alt="people" class="w-md-100 mw-400" *ngIf="isMobile" />
			<img src="/assets/images/home/travelers-photos-placeholder@2x.png" alt="people" class="w-md-100 mw-400" *ngIf="!isMobile" />
		</div>
		<div class="info mb-4 w-lg-50">
			<h5 class="subtitle font-family-accent font-weight-semibold text-headline">Help & Support</h5>
			<h2 class="title font-family-accent font-weight-bold text-headline">Your Safety & Our Philosophy</h2>

			<ng-template #noTabListSafety>
				<div class="my-3">No tabs found.</div>
			</ng-template>
	
			<ng-container *ngIf="tabListSafety$ | async as tabListSafety; else noTabListSafety">
				<ascedia-accordion-tab-group
					[tabList]="tabListSafety"
					className="font-weight-medium mb-4 mb-lg-2"
					textColor="#0D5487"
					lineColor="#ced4da"
				></ascedia-accordion-tab-group>
			</ng-container>

			<a class="btn btn-primary pill font-weight-bold" [routerLink]="['/about-us/our-story']" routerLinkActive="router-link-active" >View Our Vision</a>


		</div>
	</div>
</div>
